import { useQuery } from 'react-query';
import { User } from '../entities/User';
import { UserService } from '../services/UserService';

const useCurrentUser = () =>
  useQuery<User>(['user', 'me'], async () => {
    return await UserService.get();
  });

export default useCurrentUser;
